import Apis from '@/Apis/_'
import ResponseApi from '../interfaces/FactoryResponse'
import { CoreBase, ICoreBase } from './CoreBase'

class Cancelamento extends CoreBase implements ICancelamento {
  async cancelarSolicitacao(params: any): Promise<ResponseApi> {
    const response = await Apis.Agendamento.AgendamentoMedicoBackofficeApi
      .cancelarSolicitacao(params.solicitacaoId, params.tipoOrigem, params)
    return response
  }

  async solicitaCancelamentoSolicitacao(params: any): Promise<ResponseApi> {
    const response = await Apis.Agendamento.AgendamentoMedicoBackofficeApi
      .solicitaCancelamentoSolicitacao(params.solicitacaoId, params.motivo)
    return response
  }

  async cancelarSolicitacaoMedico(params: any): Promise<ResponseApi> {
    const response = await Apis.Agendamento.AgendamentoMedicoBackofficeApi
      .cancelarSolicitacaoMedico(params.solicitacaoId, params.motivo, params.observacaoDoCancelamento)
    return response
  }

  async deactivateDoctorSurgerySolicitation(surgerySolicitationId, body): Promise<ResponseApi> {
    const response = await Apis.Agendamento.AgendamentoMedicoBackofficeApi
      .deactivateDoctorSurgerySolicitation(surgerySolicitationId, body)
    return response
  }

  async getMotivosCancelamentoAll(params: any): Promise<ResponseApi> {
    const response = await Apis.Agendamento.AgendamentoMedicoBackofficeApi
      .getMotivosCancelamentoAll(params)
    return response
  }
}

interface ICancelamento extends ICoreBase {
  cancelarSolicitacao(params: any): Promise<ResponseApi>
  solicitaCancelamentoSolicitacao(params: any): Promise<ResponseApi>
  getMotivosCancelamentoAll(params: any): Promise<ResponseApi>
  cancelarSolicitacaoMedico(params: any): Promise<ResponseApi>
  deactivateDoctorSurgerySolicitation(surgerySolicitationId, body): Promise<ResponseApi>
}

export {
  Cancelamento,
  ICancelamento,
}
